import { SelectOption } from '@globaleris/ui.library'
import { EnumCommodity, EnumTipoSujeto } from '../../..'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import {
  ActiveContractsFilterModel,
  LandingSubjectAnnouncementFilterModel,
  LandingSujectKpisModel,
  SubjectAnnouncementModel,
  SubjectFilterModel,
  SubjectModel,
  SubjectTableModel
} from '../../../../pages/clients/clients.model'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { Account } from '../../model/subjects'
import { sanitizeQuery } from '../../../../helpers/sanitizeQueryHelper'

export const apiFetchClientSubtypes = async (subjectType: EnumTipoSujeto): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Subjects/FetchClientSubtypes?subjectType=${subjectType}`
  ).then(response => {
    if (response.data && response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchPersonTypes = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Subjects/FetchPersonTypes`).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchDocumentTypes = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Subjects/FetchDocumentTypes`).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFetchLanguage = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Subjects/FetchLanguage`).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchNotificationTypes = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Subjects/FetchNotificationTypes`).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFetchMunicipalities = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Subjects/FetchMunicipalities`).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFetchProvinces = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Subjects/FetchProvinces`).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchCountries = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Subjects/FetchCountries`).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchResidenceTypes = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Subjects/FetchResidenceTypes`).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFetchCommodityTypes = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Subjects/FetchCommodityTypes`).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFetchSubjectsByTypeAndCommodity = async (
  subjectType: EnumTipoSujeto,
  commodity: EnumCommodity
): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Subjects/FetchSubjectsByTypeAndCommodity?subjectType=${subjectType}&commodity=${commodity}`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiSaveClient = async (client: SubjectModel): Promise<SubjectModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Subjects/PostSubject`, client).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiGetClient = async (clientId: number): Promise<SubjectModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Subjects/GetSubject?clientID=${clientId}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetClientByDocument = async (fiscalDocument: string): Promise<SubjectModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Subjects/GetSubjectsByDocument?document=${fiscalDocument}`
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiUpdateClient = async (client: SubjectModel): Promise<SubjectModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.patch(`${apiSuffixUrl}/api/Subjects/PatchSubject`, client).then(
    response => {
      if (response.data) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiGetSubjects = async (
  subjectFilter: SubjectFilterModel
): Promise<SubjectTableModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  // Sanitize searchText to prevent SQL injections - only allow alphanumeric characters
  const sanitizedFilter = {
    ...subjectFilter,
    searchText: subjectFilter.searchText ? sanitizeQuery(subjectFilter.searchText) : undefined
  }

  return await AxiosInstance.post(
    // `https://localhost:59923/api/Subjects/GetSubjects`,
    `${apiSuffixUrl}/api/Subjects/GetSubjects`,
    sanitizedFilter
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetSubjectFathers = async (): Promise<SelectOption[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Subjects/GetSubjectFathers`).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiFetchListAnnouncement = async (
  filter: LandingSubjectAnnouncementFilterModel
): Promise<SubjectAnnouncementModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(
    `${apiSuffixUrl}/api/LandingSubject/GetLandingAnnouncement`,
    filter
  ).then(response => {
    return response.data
  })
}

export const apiFetchListKpis = async (
  filter: ActiveContractsFilterModel
): Promise<LandingSujectKpisModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/LandingSubject/GetLandingKpis`, filter).then(
    response => {
      return response.data
    }
  )
}

export const apiGetAccountsForSubject = async (subjectID: number): Promise<Account[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:65521'

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Subjects/GetAccountsForSubject/${subjectID}`
  ).then(response => {
    return response.data
  })
}

export const apiGetCUPSBySubjectId = async (subjectID: number): Promise<Record<number, string>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  //const apiSuffixUrl = 'https://localhost:59140'

  return await AxiosInstance.get<Record<number, string>>(
    `${apiSuffixUrl}/api/Subjects/GetCUPSBySubjectId/${subjectID}`
  ).then(response => {
    return response.data
  })
}
